import {
    AccessBayScheduling,
    AccessHaulerManagement,
    AccessPlantManagement,
    AccessProducerManagement,
    CanImpersonateUsers,
    Dashboard,
    GetMilkScheduleDetails,
    ListAdmins,
    ListCIPWash,
    ListDrivers,
    ListDropoffs,
    ListHaulingCompanies,
    ListInvoicing,
    ListLabReports,
    ListManifests,
    ListMonthlyReports,
    ListPickups,
    ListPickupsAndLabs,
    ListProcessors,
    ListProducers,
    ListReceivers,
    ListRouteSessions,
    ListScheduleRoutes,
    ListSharedFiles,
    ListSubAdmins,
    ListSubHauling,
    ListSubProcessors,
    ListSubProducers,
    ListTrailers,
    ListUserGroups,
    ListUserGroupsV2,
    ManageAssignees,
    ManageBankingInfo,
    ManageClosePeriod,
    ManageCustomFields,
    ManageDeferrals,
    ManageDeliveryReports,
    ManageEquity,
    ManageHaulerAssignments,
    ManageHaulerPayReports,
    ManageHaulerRates,
    ManageHaulingCharges,
    ManageHaulingContracts,
    ManageLinkedUsers,
    ManageMilkPrices,
    ManageMooRules,
    ManagePaymentStatus,
    ManagePoolingDecisions,
    ManageProcessorTotals,
    ManageProducerAssignments,
    ManageProducerPayReports,
    ManageProducerTouchBases,
    ManageSplitProducers,
    ManageVendorPayReports,
    OverrideQualityStatus,
    ProducerHaulingContractsAndCharges,
    UploadDownload,
    UploadMooRules,
    ViewAccountingReports,
    ViewDocumentation,
    ViewDriverLocations,
    ViewMemberCenter,
    ViewReceivingDropoffs,
    ViewMilkPredictionReport,
    ViewContracts,
    ViewContractPerformanceReport,
    ViewSupplyOutlookReport,
    ViewReporting,
    ViewMilkInspectorsReport,
} from './permissions';
import LABELS from './constants';

const region = 'UNC';

const SubAdminManagement = {
    label: LABELS.Management,
    permissions: [
        ListAdmins,
        ListProducers,
        ListSubProducers,
        ListDrivers,
        ListReceivers,
        ListProcessors(region),
        ListSubProcessors(region),
        ListHaulingCompanies(region),
        ListSubHauling(region),
        ListTrailers,
        ListSubAdmins,
        ManageLinkedUsers,
        CanImpersonateUsers,
        // force wrap
    ],
};

const SubAdminPooling = {
    label: LABELS.Pooling,
    permissions: [
        ManagePoolingDecisions,
        ManageProcessorTotals,
        ManageProducerTouchBases,
        // force wrap
    ],
};

const SubAdminGeneral = {
    label: LABELS.General,
    permissions: [
        Dashboard,
        ListUserGroups,
        ListUserGroupsV2,
        ViewDriverLocations,
        ListScheduleRoutes,
        ManageClosePeriod,
        ListPickups(),
        ListDropoffs(),
        ListInvoicing,
        ListCIPWash,
        ListLabReports(),
        UploadDownload,
        ListRouteSessions(region),
        ManageDeliveryReports,
        ListManifests,
        GetMilkScheduleDetails(),
        OverrideQualityStatus,
        ListSharedFiles,
        ViewDocumentation,
        ViewReceivingDropoffs,
        AccessPlantManagement,
        ViewMemberCenter,
        AccessHaulerManagement,
        AccessProducerManagement,
        ManageEquity,
        AccessBayScheduling,
        ViewContracts,
        ManageCustomFields,
        ViewMilkPredictionReport,
        ViewContractPerformanceReport,
        ViewSupplyOutlookReport,
        ViewReporting,
        ViewMilkInspectorsReport,
    ],
};

const SubAdminAccounting = {
    label: LABELS.Accounting,
    permissions: [
        ViewAccountingReports,
        ManageProducerAssignments,
        ManageHaulerAssignments,
        ManageAssignees,
        ManageMilkPrices,
        ManageDeferrals,
        ManageSplitProducers,
        ManageHaulingCharges(),
        ManageHaulingContracts(),
        ManageHaulerRates,
        ManageProducerPayReports,
        ManageMooRules,
        ManageHaulerPayReports,
        ManageVendorPayReports,
        ManagePaymentStatus,
        ManageBankingInfo,
        UploadMooRules,
        // force wrap
    ],
};
const AdminAccounting = {
    label: LABELS.Accounting,
    permissions: [
        ViewAccountingReports,
        ManageProducerAssignments,
        ManageHaulerAssignments,
        ManageAssignees,
        ManageMilkPrices,
        ManageDeferrals,
        ManageSplitProducers,
        ManageHaulingCharges(),
        ManageHaulingContracts(),
        ManageHaulerRates,
        ManageProducerPayReports,
        ManageMooRules,
        ManageHaulerPayReports,
        ManageVendorPayReports,
        ManagePaymentStatus,
        ManageBankingInfo,
        UploadMooRules,
        // force wrap
    ],
};

const SubProducerManagement = {
    label: LABELS.Management,
    permissions: [ListSubProducers],
};

const SubProducerGeneral = {
    label: LABELS.General,
    permissions: [
        Dashboard,
        ListPickups(),
        ListPickupsAndLabs,
        ListLabReports(),
        ListSharedFiles,
        ViewMemberCenter,
        ViewReporting,
        AccessProducerManagement,
        // force wrap
    ],
};

const SubProducerAccounting = {
    label: LABELS.Accounting,
    permissions: [ListMonthlyReports(region)],
};

const SubProcessorManagement = {
    label: LABELS.Management,
    permissions: [ListSubProcessors('View', ''), ListReceivers],
};

const SubProcessorGeneral = {
    label: LABELS.General,
    permissions: [
        Dashboard,
        ListDropoffs(),
        ListInvoicing,
        ListRouteSessions(),
        GetMilkScheduleDetails(),
        ListSharedFiles,
        ViewReceivingDropoffs,
        AccessPlantManagement,
        AccessBayScheduling,
        ViewReporting,
        // force wrap
    ],
};

const SubHaulingManagement = {
    label: LABELS.Management,
    permissions: [ListDrivers, ListTrailers, ListSubHauling('View', '')],
};

const SubHaulingGeneral = {
    label: LABELS.General,
    permissions: [
        Dashboard,
        ViewDriverLocations,
        ListPickups(),
        ListDropoffs(),
        ListCIPWash,
        GetMilkScheduleDetails(),
        ListSharedFiles,
        ViewReceivingDropoffs,
        AccessHaulerManagement,
        ViewReporting,
        // force wrap
    ],
};

const SubHaulingAccounting = {
    label: LABELS.Accounting,
    permissions: [ProducerHaulingContractsAndCharges, ListMonthlyReports(region)],
};
const Admin = [SubAdminManagement, SubAdminGeneral, AdminAccounting, SubAdminPooling];
const SubAdmin = [SubAdminManagement, SubAdminGeneral, SubAdminAccounting, SubAdminPooling];
const SubProducer = [SubProducerManagement, SubProducerGeneral, SubProducerAccounting];
const SubProcessor = [SubProcessorManagement, SubProcessorGeneral];
const SubHauling = [SubHaulingManagement, SubHaulingGeneral, SubHaulingAccounting];

const UNC = {
    Admin: { permissions: Admin },
    'Sub-Admin': { permissions: SubAdmin },
    'Sub-Producer': { permissions: SubProducer },
    Accountant: { permissions: SubProducer },
    'Feed-Provider': { permissions: SubProducer },
    Nutritionist: { permissions: SubProducer },
    'Co-Owner': { permissions: SubProducer },
    'Sub-Processor': { permissions: SubProcessor },
    'Sub-Hauling': { permissions: SubHauling },
};

export default UNC;
